export function formatApiDateForDisplay(value) {
  if (value == null || value === "") {
    return "";
  }
  const s = String(value).trim();
  if (!s) {
    return "";
  }
  return s.includes("T") ? s.split("T")[0] : s;
}

export function todayIsoDate() {
  return new Date().toISOString().split("T")[0];
}

function parseIsoDateOnly(dateStr) {
  const s = String(dateStr ?? "").trim();
  if (!s) {
    return null;
  }
  const parts = s.split("-").map((p) => Number.parseInt(p, 10));
  if (parts.length !== 3 || parts.some((n) => !Number.isFinite(n))) {
    return null;
  }
  const [year, month, day] = parts;
  return new Date(year, month - 1, day);
}

/** Service is expired when end date is set and today is on or after that date. */
export function serviceIsExpired(service) {
  const end = String(service?.endDate ?? "").trim();
  if (!end) {
    return false;
  }
  const endDate = parseIsoDateOnly(end);
  const today = parseIsoDateOnly(todayIsoDate());
  if (!endDate || !today) {
    return false;
  }
  return endDate.getTime() <= today.getTime();
}

/** Active when end date is null/empty or today is before the end date. */
export function serviceIsActive(service) {
  return !serviceIsExpired(service);
}

export function serviceHasEndDate(service) {
  return Boolean(service?.isEnded || String(service?.endDate ?? "").trim());
}

/** End date with hover shadow box showing who applied the end date. */
export function ServiceEndDateCell({ endDate, appliedByDisplayName }) {
  const end = String(endDate ?? "").trim();
  if (!end) {
    return <div className="text-gray-600 dark:text-gray-400 break-words">{"\u2014"}</div>;
  }
  const appliedBy = String(appliedByDisplayName ?? "").trim();
  return (
    <span className="relative inline-flex group">
      <span
        className="text-gray-600 dark:text-gray-400 break-words cursor-help underline decoration-dotted decoration-gray-500/60 underline-offset-2 dark:decoration-gray-400/60"
        aria-label={
          appliedBy
            ? `End date ${end}; hover for who applied it`
            : `End date ${end}`
        }
      >
        {end}
      </span>
      {appliedBy ? (
        <span
          role="tooltip"
          className="pointer-events-none absolute left-0 top-full z-30 mt-2 min-w-[14rem] max-w-sm rounded-lg border border-gray-200 bg-white p-3 text-left shadow-lg opacity-0 invisible transition-[opacity,visibility] duration-150 group-hover:opacity-100 group-hover:visible dark:border-gray-600 dark:bg-gray-900 dark:shadow-black/40"
        >
          <p className="text-sm text-gray-900 dark:text-gray-100 break-words">
            Applied by: {appliedBy}
          </p>
        </span>
      ) : null}
    </span>
  );
}
